import { DetailedCellError } from "@inscopix/ideas-hyperformula";
import { BadgePlain } from "../plain/BadgePlain";

interface CellValueRendererErrorProps {
  error: DetailedCellError;
}

/** Component that renders a `DetailedCellError` cell value` */
export const CellValueRendererError = ({
  error,
}: CellValueRendererErrorProps) => {
  return <BadgePlain color="#fec514">ERROR</BadgePlain>;
};
